 import { makeStyles } from "@material-ui/styles"

const useStyle = makeStyles(() => ({
  root: {
    "-webkit-transition": "opacity 0.4s ease",
    transition: "opacity 0.4s ease",
  }
}));

export default useStyle;